import { Component, ViewEncapsulation } from "@angular/core";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";

@Component({
  selector: "uni-quickbooks-integration-doc",
  standalone: false,
  templateUrl: "./quickbooks-integration-doc.component.html",
  encapsulation: ViewEncapsulation.None,
  host: { class: "flex flex-col flex-1 overflow-hidden" },
})
export class QuickbooksIntegrationDocComponent extends DomainBaseComponent {
  mdSrc = "/assets/docs/quickbooks-integration.md";

  constructor(domainService: DomainService) {
    super(domainService);
    this.isPageReady = true;
  }
}
